import React from 'react';
import { CloudSyncOutlined, DownloadOutlined } from '@ant-design/icons';
import { Space, Row, DatePicker, Button, Form } from 'antd';
import { useIntl, FormattedMessage } from 'react-intl';
import type { Dayjs } from 'dayjs';
import { useQueryClient } from '@tanstack/react-query';
import { useLoadDepExport } from 'RKSV/hooks/exports';
import { download } from 'RKSV/utils';
import { DepExport } from 'utils/apiClient/services/rksv/types';

const { RangePicker } = DatePicker;

interface FormValues {
  dateRange: [Dayjs, Dayjs];
}
const dateFormat = 'DD.MM.YYYY';

const DepExportContainer = () => {
  const intl = useIntl();
  const queryClient = useQueryClient();
  const depExportMutation = useLoadDepExport();
  const depExport = queryClient.getQueryData(['rksv', 'depexport']);

  const onClick = () => {
    const depData = JSON.stringify(
      queryClient.getQueryData(['rksv', 'depexport'])
    );
    download(depData, 'depExport.json', 'application/json');
  };

  const handleSubmit = ({ dateRange }: FormValues) => {
    depExportMutation.mutate({
      from: dateRange[0].startOf('day').format(),
      to: dateRange[1].endOf('day').format(),
    });
  };

  return (
    <>
      <Row>
        <h3>
          <FormattedMessage defaultMessage="Select dates to be exported" />
        </h3>
      </Row>

      <Form<FormValues> layout="horizontal" onFinish={handleSubmit}>
        <Row>
          <Space>
            <Form.Item
              name="dateRange"
              rules={[
                {
                  required: true,
                  message: intl.formatMessage({
                    defaultMessage: 'This field is required',
                  }),
                },
              ]}
            >
              <RangePicker
                format={[dateFormat, dateFormat]}
                data-testid="date"
              />
            </Form.Item>
            <Button
              type="primary"
              icon={<CloudSyncOutlined />}
              htmlType="submit"
              data-testid="generate-report"
              css="margin-bottom: 24px"
            >
              <FormattedMessage defaultMessage="Generate" />
            </Button>
            {depExport && (
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={onClick}
                disabled={!(depExport as DepExport)?.['Belege-Gruppe']}
                data-testid="download-report"
              >
                <FormattedMessage defaultMessage="Download" />
              </Button>
            )}
          </Space>
        </Row>
      </Form>
    </>
  );
};

export default DepExportContainer;
